import { useEffect, useState } from "react";
import Content from "../../components/content/Content";
import ContentHead from "../../components/content/ContentHead";
import ContentBody from "../../components/content/ContentBody";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faPlus } from "@fortawesome/free-solid-svg-icons";
import InputField from "../../components/inputField/inputField";
import ToggleSwitch from "../../components/toggleSwitch";
import TextEditor from "../../components/textEditor/textEditor";
import { addUpdateApi, getAllApi, uploadImageApi } from "../../api";
import toast from "react-hot-toast";
import { isValidURL } from "../../utils/isValidUrl";

const IndustryPage = () => {
  const [isChanged, setIsChanged] = useState(false);
  const [hero, setHero] = useState([]);
  const [slug, setSlug] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [metaImageUrl, setMetaImageUrl] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [canonicalUrl, setCanonicalUrl] = useState("");

  const [id, setId] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    getAllApi("industryPage")
      .then((res) => {
        if (res.data.length !== 0) {
          setId(res.data[0]._id);
          setHero(
            res.data[0]?.hero?.map((v) => ({
              ...v,
              image: { url: v.image, obj: "" },
            }))
          );
          const val = res.data[0].metaData;
          setSlug(val?.slug);
          setMetaTitle(val?.metaTitle);
          setMetaDescription(val?.metaDescription);
          setMetaImageUrl(val?.metaImageUrl);
          setCanonicalUrl(val?.canonicalUrl);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const getHero = async () => {
    let value = [];

    for (let i = 0; i < hero.length; i++) {
      const temp = hero[i];

      if (temp.image.obj) {
        const r = await uploadImageApi(temp.image.obj);
        value.push({ ...hero[i], image: r.data.imageUrl });
      } else {
        value.push({ ...hero[i], image: temp.image.url });
      }
    }

    return value;
  };

  const validate = () => {
    if (hero.length === 0) {
      toast.error("Hero is required.");
      return false;
    }

    for (let i = 0; i < hero.length; i++) {
      if (!hero[i].image.url) {
        toast.error("Hero image is required.");
        return false;
      }
      if (!hero[i].imageCaption) {
        toast.error("Hero Image caption is required.");
        return false;
      }
      if (!hero[i].imageAlt) {
        toast.error("Hero Image Alt is required.");
        return false;
      }
      if (!hero[i].title) {
        toast.error("Hero Title is required.");
        return false;
      }
      if (!hero[i].subHeading) {
        toast.error("Hero Sub heading is required.");
        return false;
      }
      if (!hero[i].description) {
        toast.error("Hero Description is required.");
        return false;
      }
    }

    if (!slug) {
      toast.error("Slug is required.");
      return false;
    }
    if (!metaTitle) {
      toast.error("Meta Title is required.");
      return false;
    }
    if (!metaImageUrl) {
      toast.error("Meta Image Url is required.");
      return false;
    }
    if (!isValidURL(metaImageUrl)) {
      toast.error("Meta Image Url is invalid.");
      return false;
    }
    if (!metaDescription) {
      toast.error("Meta Description is required.");
      return false;
    }
    if (!canonicalUrl) {
      toast.error("Canonical Url is required.");
      return false;
    }
    if (!isValidURL(canonicalUrl)) {
      toast.error("Canonical Url is invalid.");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (validate()) {
      setLoading(true);

      const data = {
        hero: await getHero(),
        metaData: {
          slug,
          metaTitle,
          metaDescription,
          metaImageUrl,
          canonicalUrl,
        },
      };

      addUpdateApi({ data, type: "industryPage", method: "patch", id })
        .then((res) => {
          getData();
          toast.success("Updated Successfully.");
          setIsChanged(false);
        })
        .catch((err) => {
          toast.error("Something went wrong while updating technology page.");
          setLoading(false);
        });
    }
  };

  return (
    <>
      {loading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            background: "rgba(0,0,0,.3)",
            zIndex: 100000,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span className="loader"></span>
        </div>
      )}
      <Content>
        <ContentHead
          title="Industries Page"
          showBtn1={isChanged}
          btn1Text="Save"
          btn1type="filled"
          btn1Name="btn1"
          showBtn2={isChanged}
          btn2Text="Cancel"
          btn2type="outlined_del"
          btn2Name="btn2"
          onClickHandler={(e) => {
            if (e.target.name === "btn1") {
              handleSubmit();
            } else {
              setLoading(true);
              getData();
            }
          }}
        />
        <ContentBody>
          <div className="grid">
            <div className="card grid">
              <h3>
                Hero Carousel
                <button
                  onClick={() => {
                    setHero((prev) => [
                      ...prev,
                      {
                        image: { url: "", obj: "" },
                        imageCaption: "",
                        imageAlt: "",
                        title: "",
                        subHeading: "",
                        description: "",
                      },
                    ]);
                    setIsChanged(true);
                  }}
                >
                  <FontAwesomeIcon icon={faPlus} />
                  Add
                </button>
              </h3>
              {hero.map((h, index) => {
                return (
                  <div key={index} className="sub_card grid">
                    <FontAwesomeIcon
                      className="sub_card_close"
                      icon={faClose}
                      onClick={() => {
                        const temp = [...hero];
                        temp.splice(index, 1);
                        setHero(temp);
                      }}
                    />
                    <div>
                      <p style={{ fontSize: ".9rem" }}>Image</p>
                      {h.image.url ? (
                        <div
                          style={{
                            width: "70px",
                            height: "70px",
                            background: "var(--blue-light)",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "5px",
                            position: "relative",
                          }}
                        >
                          <FontAwesomeIcon
                            icon={faClose}
                            style={{
                              color: "var(--blue-dark)",
                              cursor: "pointer",
                              height: "15px",
                              width: "15px",
                              padding: "5px",
                              position: "absolute",
                              top: 0,
                              right: 0,
                              transform: "translate(50%, -50%)",
                            }}
                            onClick={() => {
                              let temp = [...hero];
                              temp[index].image = { url: "", obj: "" };
                              setHero(temp);
                              setIsChanged(true);
                            }}
                          />
                          <img
                            src={h.image.url}
                            alt=""
                            style={{
                              height: "100%",
                              width: "100%",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      ) : (
                        <div
                          style={{
                            width: "70px",
                            height: "70px",
                            position: "relative",
                            background: "var(--blue-light)",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "5px",
                          }}
                        >
                          <input
                            type="file"
                            style={{
                              position: "absolute",
                              top: 0,
                              bottom: 0,
                              left: 0,
                              right: 0,
                              opacity: 0,
                            }}
                            accept="image/*"
                            onChange={(e) => {
                              let temp = [...hero];
                              temp[index].image = {
                                url: URL.createObjectURL(e.target.files[0]),
                                obj: e.target.files[0],
                              };
                              setHero(temp);
                              setIsChanged(true);
                            }}
                          />
                          <FontAwesomeIcon
                            icon={faPlus}
                            style={{ color: "var(--blue-dark)" }}
                          />
                        </div>
                      )}
                    </div>
                    {h.image?.url && (
                      <div className="grid_2">
                        <InputField
                          type="text"
                          isLabel={true}
                          lable={"Image Caption"}
                          value={h.imageCaption}
                          onChange={(e) => {
                            let temp = [...hero];
                            temp[index].imageCaption = e.target.value;
                            setHero(temp);
                            setIsChanged(true);
                          }}
                        />
                        <InputField
                          type="text"
                          isLabel={true}
                          lable={"Image Alt"}
                          value={h.imageAlt}
                          onChange={(e) => {
                            let temp = [...hero];
                            temp[index].imageAlt = e.target.value;
                            setHero(temp);
                            setIsChanged(true);
                          }}
                        />
                      </div>
                    )}
                    <InputField
                      type="text"
                      value={h.title}
                      onChange={(e) => {
                        let temp = [...hero];
                        temp[index].title = e.target.value;
                        setHero(temp);
                        setIsChanged(true);
                      }}
                      isLabel={true}
                      lable="Title"
                      showCharLength={true}
                      limitChar={40}
                    />
                    <InputField
                      type="text"
                      value={h.subHeading}
                      onChange={(e) => {
                        let temp = [...hero];
                        temp[index].subHeading = e.target.value;
                        setHero(temp);
                        setIsChanged(true);
                      }}
                      isLabel={true}
                      lable="Sub Heading"
                    />
                    <InputField
                      type="textarea"
                      value={h.description}
                      onChange={(e) => {
                        let temp = [...hero];
                        temp[index].description = e.target.value;
                        setHero(temp);
                        setIsChanged(true);
                      }}
                      isLabel={true}
                      lable="Description"
                    />
                  </div>
                );
              })}
            </div>
            {/* Meta Data */}
            <div className="card grid">
              <InputField
                isLabel={true}
                lable="Slug"
                value={slug}
                onChange={(e) => {
                  setSlug(e.target.value);
                  setIsChanged(true);
                }}
              />
              <InputField
                isLabel={true}
                lable="Meta Title"
                value={metaTitle}
                onChange={(e) => {
                  setMetaTitle(e.target.value);
                  setIsChanged(true);
                }}
              />
              <InputField
                isLabel={true}
                lable="Meta Image Url"
                value={metaImageUrl}
                onChange={(e) => {
                  setMetaImageUrl(e.target.value);
                  setIsChanged(true);
                }}
              />
              <InputField
                isLabel={true}
                lable="Meta Description"
                value={metaDescription}
                onChange={(e) => {
                  setMetaDescription(e.target.value);
                  setIsChanged(true);
                }}
              />
              <InputField
                isLabel={true}
                lable="Canonical Url"
                value={canonicalUrl}
                onChange={(e) => {
                  setCanonicalUrl(e.target.value);
                  setIsChanged(true);
                }}
              />
            </div>
          </div>
        </ContentBody>
      </Content>
    </>
  );
};

export default IndustryPage;
